import React, { useEffect, useState } from "react";
import QuickSearchResult from "../Components/QuickSearchResult";
import { SearchResult } from "../Types/SearchResult.interface";

export default function SearchResultPage() {
    const [searchResults, setSearchResults] = useState<SearchResult | null>(null);

    useEffect(() => {
        const resultJson = localStorage.getItem("quickSearchResult");
        if (resultJson) {
            setSearchResults(JSON.parse(resultJson));
        }
    }, []);

    return (
        <div>
            {searchResults ? (
                <div className={"page-title"}>
                    <QuickSearchResult results={searchResults} />
                </div>
            ) : (
                <p>Aucun résultat disponible.</p>
            )}
        </div>
    );
}
